import React from "react";
import { Container, Table, Row, Col } from "react-bootstrap";
import Contact from "../components/Contact";
import Header from "../components/Header";

function aboutScreen() {
  return (
    <>
      <Header />
      <Contact />
    </>
  );
}

export default aboutScreen;
